import { render, staticRenderFns } from "./step3.vue?vue&type=template&id=132db67e&scoped=true"
import script from "./step3.vue?vue&type=script&lang=js"
export * from "./step3.vue?vue&type=script&lang=js"
import style0 from "./step3.vue?vue&type=style&index=0&id=132db67e&prod&lang=less&scoped=true"
import style1 from "./step3.vue?vue&type=style&index=1&id=132db67e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132db67e",
  null
  
)

export default component.exports